import React from 'react';
import Logger from '../../util/Logger';
import { connect } from 'react-redux';
import Dropdown from '../shared/Dropdown';
import './ConfigurationDefaults.css';
import User from '../../models/User';
import { updateConfigurationDefaults } from '../../actions/configurationDefaults';
import { handleErrorWithDialog } from '../../util/Errors';
import { showDialog } from '../../actions/dialog';
import AuthorizedCreators from './AuthorizedCreators';
import { fetchSelfLaunchList } from '../../actions/selfLaunchAllowed';
import Tenant from '../../models/Tenant';
import { Switch } from '../shared/Switch';
import { PAGE_LINK_RESTRICT_ERROR, PAGE_LINK_COC_EXPLAIN } from '../../constants';
import { EnterpriseSettings } from '../../analytics/EnterpriseSettings';
import { NavigationUtils } from '../../util/NavigationUtils';

class ConfigurationDefaults extends React.Component {
  handleOnRestrictExplanationClicked = ($event) => {
    $event.preventDefault();
    EnterpriseSettings.learnMoreRestrictCreation();
    NavigationUtils.openTab(PAGE_LINK_RESTRICT_ERROR);
  };

  handleOnCOCExplanationClicked = ($event) => {
    $event.preventDefault();
    EnterpriseSettings.learnMoreCOC();
    NavigationUtils.openTab(PAGE_LINK_COC_EXPLAIN);
  };

  onRestrictPopinCreationChanged = (checked) => {
    Logger.info(`restrict popin creation switch changed: ${checked}`);

    const restrict = () => this.setState({ restrictPopin: checked }, () => {
      this.commitChanges();
      EnterpriseSettings.restrictCreation(checked);
    });

    if (checked) {
      const { showDialog } = this.props;
      showDialog({
        title: 'Restrict POPin creation?',
        body: (
          <div>
            Are you sure you want to restrict POPin creation within your
            <br />organization? Doing this will make it difficult for your organization to
            <br />fully benefit from POPin. <span
            className="link"
            onClick={ this.handleOnRestrictExplanationClicked }>Learn more</span>
            <br />
            <br />
            You will need to add users to the authorized list once restriction is
            <br />turned on.
          </div>),
        ok: 'Ok',
        cancel: 'Cancel',
        onOk: () => {
          EnterpriseSettings.restrictCreationModalOK();
          restrict();
        },
        onCancel: () => {EnterpriseSettings.restrictCreationModalCancel();}
      });
    } else {
      restrict();
    }
  };

  onShowCodeOfConductChanged = (checked) => {
    Logger.info(`show code of conduct switch changed: ${checked}`);
    EnterpriseSettings.showCoCToggled(checked);
    this.setState({
      showCodeOfConduct: checked
    }, this.commitChanges);
  };

  // onAllowPdfsChanged = (checked) => {
  //   Logger.info(`allow pdfs switch changed: ${checked}`);
  //   this.setState({
  //     allowPdf: checked
  //   });
  // };
  // onAllowImagesChanged = (checked) => {
  //   Logger.info(`allow images switch changed: ${checked}`);
  //   this.setState({
  //     allowImages: checked
  //   });
  // };
  // handleSaveButtonClick = ($event) => {
  //   $event.preventDefault();
  //
  // };

  onShortLinkChanged = (item) => {
    EnterpriseSettings.editLinkType(item.id);
    this.setState({
      shortLinks: !!item.short
    }, this.commitChanges);
  };

  commitChanges = () => {
    const { user, updateConfigurationDefaults } = this.props;
    if (user && updateConfigurationDefaults) {
      if (this.hasConfigurationChanges()) {
        const {
          restrictPopin,
          showCodeOfConduct,
          allowPdf,
          allowImages,
          shortLinks
        } = this.getConfigurationChangesPayload();
        updateConfigurationDefaults(Tenant.getId(User.getTenant(user)),
          restrictPopin,
          showCodeOfConduct,
          allowPdf,
          allowImages,
          shortLinks);
      }
    }
  };

  getConfigurationChangesPayload = () => {
    const restrictPopin = (this.state.restrictPopin !== this.props.restrictPopin)
      ? this.state.restrictPopin
      : null;
    const showCodeOfConduct = (this.state.showCodeOfConduct !== this.props.showCodeOfConduct)
      ? this.state.showCodeOfConduct
      : null;
    const allowPdf = (this.state.allowPdf !== this.props.allowPdf)
      ? this.state.allowPdf
      : null;
    const allowImages = (this.state.allowImages !== this.props.allowImages)
      ? this.state.allowImages
      : null;
    const shortLinks = (this.state.shortLinks !== this.props.shortLinks)
      ? this.state.shortLinks
      : null;
    return { restrictPopin, showCodeOfConduct, allowPdf, allowImages, shortLinks };
  };

  hasConfigurationChanges = () => {
    const { restrictPopin, showCodeOfConduct, allowPdf, allowImages, shortLinks } = this.getConfigurationChangesPayload();
    return !(restrictPopin === null &&
      showCodeOfConduct === null &&
      allowPdf === null &&
      allowImages === null &&
      shortLinks === null);
  };
  didAdminsListChange = (newAdmins, oldAdmins) => {
    return newAdmins && oldAdmins &&
      newAdmins !== oldAdmins &&
      newAdmins.length !== oldAdmins.length;
  };

  constructor (props) {
    super(props);

    const { user } = this.props;
    if (!user) {
      Logger.assert('ConfigurationDefaults component cannot be used without a User object');
    }

    const { restrictPopin, showCodeOfConduct, allowPdf, allowImages, shortLinks } = this.props;

    // We track the state so that UI changes are instant, but we always map the state to props
    // so that we stay synced with the latest server stuff
    this.state = {
      restrictPopin: !!restrictPopin,
      showCodeOfConduct: !!showCodeOfConduct,
      allowPdf: !!allowPdf,
      allowImages: !!allowImages,
      shortLinks: !!shortLinks
    };
  }

  componentWillReceiveProps (nextProps) {
    if (!nextProps.configUpdating &&
      !this.didAdminsListChange(nextProps.admins, this.props.admins)) {
      // We track the state so that UI changes are instant, but we always map the state to props
      // so that we stay synced with the latest server stuff
      this.setState({
        restrictPopin: !!nextProps.restrictPopin,
        showCodeOfConduct: !!nextProps.showCodeOfConduct,
        allowPdf: !!nextProps.allowPdf,
        allowImages: !!nextProps.allowImages,
        shortLinks: !!nextProps.shortLinks
      });
    }
  }

  componentDidUpdate (prevProps) {
    const { configError, admins, user, fetchSelfLaunchList } = this.props;

    if (this.didAdminsListChange(admins, prevProps.admins)) {
      // Admin list has changed - re-fetch the self launch list because it will change too.
      fetchSelfLaunchList(Tenant.getId(User.getTenant(user)));
    }

    handleErrorWithDialog(configError, prevProps.configError,
      'Unable to update Configuration Defaults');
  }

  render () {
    const { user } = this.props;
    const { restrictPopin, showCodeOfConduct, shortLinks } = this.state;
    return (
      <div className="card">
        <div className="row no-gutters mb-3">
          <div className="text-title my-auto">
            POPin CONFIGURATION AND DEFAULTS
          </div>
        </div>

        <div className="row no-gutters">
          <div className="text-subtitle">Share Link Type</div>
        </div>

        <div className="row no-gutters">
          <div className="col">
            <Dropdown
              id="settings-dropdown"
              text={ shortLinks
                ? 'Use short share links (e.g. popin.it/xxxxxxxx)'
                : 'Use fullsize share links (e.g. app.popinnow.com/popin/invite/xxxxxx-xxxxx-xxxxx)'
              }
              itemList={
                [
                  {
                    id: 'short',
                    text: 'Use short share links (e.g. popin.it/xxxxxxxx)',
                    short: true
                  },
                  {
                    id: 'long',
                    text: 'Use fullsize share links (e.g. app.popinnow.com/popin/invite/xxxxxx-xxxxx-xxxxx)',
                    short: false
                  }
                ]
              }
              onSelected={ this.onShortLinkChanged }
            />
          </div>
        </div>

        <br/>

        <div className="row no-gutters">
          <Switch
            id="show_code_of_conduct"
            checked={ showCodeOfConduct }
            text="Show Code of Conduct"
            onChange={ this.onShowCodeOfConductChanged } />
          &nbsp;
          <span
            className="link"
            onClick={ this.handleOnCOCExplanationClicked }>Tell me more</span>
        </div>

        <br/><br/>

        <div className="row no-gutters">
          <Switch
            id="restrict_popin_creation"
            checked={ restrictPopin }
            text="Restrict POPin creation to authorized users"
            onChange={ this.onRestrictPopinCreationChanged } />
        </div>

        <br/>

        <div className="no-gutters">
          { restrictPopin && <AuthorizedCreators user={ user } /> }
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const user = state.user.user;
  const tenant = User.getTenant(user);
  return {
    user: user,
    admins: state.accountAdmins.admins,
    restrictPopin: Tenant.isRestrictedSelfLaunch(tenant),
    showCodeOfConduct: Tenant.isShowCodeOfConduct(tenant),
    allowPdf: Tenant.isPdfsAllowed(tenant),
    allowImages: Tenant.isImagesAllowed(tenant),
    shortLinks: Tenant.isShortShareLink(tenant),
    configError: state.configurationDefaults.error,
    configUpdating: state.configurationDefaults.loading
  };
};

export default connect(mapStateToProps, {
  updateConfigurationDefaults,
  showDialog,
  fetchSelfLaunchList
})(ConfigurationDefaults);

